var queryParamsForMainLocation = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "yclid", "fbclid", "gclid", "gbraid", "wbraid"];
var getMainLocationSearch = function getMainLocationSearch(url) {
  return queryParamsForMainLocation.reduce(function (prev, param) {
    var candidate = url.searchParams.get(param);
    if (candidate) {
      prev.append(param, candidate);
    }
    return prev;
  }, new URLSearchParams()).toString();
};
export var parseMainLocation = function parseMainLocation(urlString) {
  try {
    var url = new URL(urlString);
    var search = getMainLocationSearch(url);
    return "" + url.origin + url.pathname + (search ? "?" + search : "");
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
//# sourceMappingURL=parseMainLocationUrl.js.map